export default function SubmitBusRentFormModel(email: string) {
    return {
        email,
    }
}